import React from 'react';
import { motion } from 'framer-motion';
export function AngelReveal() {
  return <section className="relative w-full min-h-[50vh] md:min-h-[60vh] overflow-hidden bg-navy" data-id="element-53">
      <motion.div initial={{
      opacity: 0,
      scale: 1.05
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 1.2,
      ease: 'easeOut'
    }} className="absolute inset-0" data-id="element-54">
        <img src="https://cdn.magicpatterns.com/uploads/eF9VfXghot34mvdvWPYoKu/Foto_de_Angel_Insurance_con_alas.png" alt="Angel Insurance of Florida" className="w-full h-full object-cover object-top" data-id="element-55" />
        {/* Dark gradient overlay from bottom */}
        <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-transparent to-transparent" data-id="element-56"></div>
      </motion.div>
    </section>;
}